import { render, staticRenderFns } from "./certifycateIndex.vue?vue&type=template&id=3845b7a6"
import script from "./certifycateIndex.vue?vue&type=script&lang=js"
export * from "./certifycateIndex.vue?vue&type=script&lang=js"
import style0 from "./certifycateIndex.vue?vue&type=style&index=0&id=3845b7a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports